// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/step.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import { hot } from 'react-hot-loader/root'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import Cover from '../cover'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Scrollchor from 'react-scrollchor'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Waypoint } from 'react-waypoint'

// TODO Set the correct article ID here
const ARTICLE_ID = '19634939'

class AppComponent extends React.Component<Props> {
  constructor(props) {
    super(props)
    this.isMobile = window.innerWidth < 600
    this.isTablet = window.innerWidth < 1025
  }

  render() {
    return (
      <div className='index'>
        <Masthead inverted articleId={ARTICLE_ID} additionalShares={352} />
        <ThemeSwitch />

        <header className='ui vertical fitted segment first'>
          <Cover
            title='Zürichs Mühen mit den Velowegen'
            subtitle='Eine Bilanz zum Masterplan Velo'
          />
        </header>
        <div className='ui container'>
          <div className='ta secondary caption'>
            {' '}
            Die Velostreifen in der Stadt Zürich sind längst nicht überall so
            breit, wie sie sein sollten. Video: Urs Jaudas
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'startReading'
              })
            }
          }}
        />

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <p className='ta lead'>
              Lückenhafte Velowege, nicht realisierte Leuchtturmprojekte: Wo
              steht die Stadt mit ihrem Masterplan Velo? Wir haben alle Ziele
              und den Fortschritt überprüft.
            </p>
            <p className='ta author' style={{ paddingTop: '2em' }}>
              Ev Manz und Mathias Lutz
            </p>
            <p>
              Da fährt man mit dem Velo gemütlich vom Zürcher Hauptbahnhof an
              der Kaserne vorbei Richtung Stauffacher und fühlt sich auf dem
              Velostreifen einigermassen sicher. Doch nach der Einfahrt
              Zeughausstrasse, wo die Strasse wegen einer Parkplatzreihe enger
              wird, fehlt eine Markierung. Vorbei ist das Wohlgefühl. Beispiele
              wie diese gibt es viele in der Stadt. Velofahrer nerven sich
              täglich über mangelhafte Infrastruktur. Grosse Verbindungen wie
              der Stadttunnel unter dem Hauptbahnhof lassen zudem auf sich
              warten. Viele finden Velofahren in Zürich gefährlich.
            </p>
            <p>
              Dabei will Zürich bis 2025 eine Velostadt sein und hat dafür 2012
              einen{' '}
              <a href='https://www.stadt-zuerich.ch/masterplanvelo.html#masterplan_velo'>
                ehrgeizigen Masterplan
              </a>{' '}
              verabschiedet. Sein Slogan: «Zürich lädt zum Velofahren ein».
            </p>
            <p>
              <a href='https://interaktiv.tagesanzeiger.ch/2019/was-zuerich-wissen-will/?nosome'>
                Unsere Leserinnen und Leser wollten wissen
              </a>
              , wo der Stadtrat mit seinem «Masterplan Velo» steht. Wir haben
              die Antwort recherchiert und zeigen auf, wo und weshalb es mit der
              Umsetzung hapert.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h2>So will die Stadt das Velofahren fördern</h2>
            <p>
              Die Stadt Zürich hat zur Veloförderung im Masterplan drei
              Hauptziele definiert und fünf Handlungsfelder festgelegt, um diese
              zu erreichen. Der TA hat diese anhand des Mobilitätsverhaltens und
              des sichtbar Erreichten bewertet.
            </p>
            <p className='instruction'>
              Weiterscrollen oder direkt zu einem Ziel/Handlungsfeld springen
            </p>
            <Scrollchor to='ziel-1'>
              <div className='todo ziel'>
                <div className='left'>
                  <img src={require('./images/bike.svg')} />
                  <div className='tag'>Ziel 1</div>
                  <div className='text'>Anteil des Veloverkehrs steigern</div>
                </div>
                <div className='right'>
                  <i className='icon check circle large' />
                </div>
              </div>
            </Scrollchor>

            <Scrollchor to='ziel-2'>
              <div className='todo ziel'>
                <div className='left'>
                  <img src={require('./images/bike.svg')} />
                  <div className='tag'>Ziel 2</div>
                  <div className='text'>Sicherheit der Velofahrer erhöhen</div>
                </div>
                <div className='right'>
                  <i className='icon x circle large red' />
                </div>
              </div>
            </Scrollchor>

            <Scrollchor to='ziel-3'>
              <div className='todo ziel'>
                <div className='left'>
                  <img src={require('./images/bike.svg')} />
                  <div className='tag'>Ziel 3</div>
                  <div className='text'>
                    Velofahren bei Kindern und Jugendlichen fördern
                  </div>
                </div>
                <div className='right'>
                  <i className='icon question circle large' />
                </div>
              </div>
            </Scrollchor>

            <Scrollchor to='handlungsfeld-1'>
              <div className='todo handlungsfeld'>
                <div className='left'>
                  <img src={require('./images/work.svg')} />
                  <div className='tag'>Handlungsfeld 1</div>
                  <div className='text'>
                    Attraktive und sichere Infrastruktur
                  </div>
                </div>
                <div className='right'>
                  <i className='icon x circle large red' />
                </div>
              </div>
            </Scrollchor>

            <Scrollchor to='handlungsfeld-2'>
              <div className='todo handlungsfeld'>
                <div className='left'>
                  <img src={require('./images/work.svg')} />
                  <div className='tag'>Handlungsfeld 2</div>
                  <div className='text'>
                    Rücksichtnahme aller Verkehrsteilnehmenden
                  </div>
                </div>
                <div className='right'>
                  <i className='icon x circle large red' />
                </div>
              </div>
            </Scrollchor>

            <Scrollchor to='handlungsfeld-3'>
              <div className='todo handlungsfeld'>
                <div className='left'>
                  <img src={require('./images/work.svg')} />
                  <div className='tag'>Handlungsfeld 3</div>
                  <div className='text'>Verkehrsmittel für alle</div>
                </div>
                <div className='right'>
                  <i className='icon check circle large' />
                </div>
              </div>
            </Scrollchor>

            <Scrollchor to='handlungsfeld-4'>
              <div className='todo handlungsfeld'>
                <div className='left'>
                  <img src={require('./images/work.svg')} />
                  <div className='tag'>Handlungsfeld 4</div>
                  <div className='text'>Verankerung in der Verwaltung</div>
                </div>
                <div className='right'>
                  <i className='icon x circle large red' />
                </div>
              </div>
            </Scrollchor>

            <Scrollchor to='handlungsfeld-5'>
              <div className='todo handlungsfeld'>
                <div className='left'>
                  <img src={require('./images/work.svg')} />
                  <div className='tag'>Handlungsfeld 5</div>
                  <div className='text'>
                    Mehr Dienstleistung und Kommunikation
                  </div>
                </div>
                <div className='right'>
                  <i className='icon question circle large' />
                </div>
              </div>
            </Scrollchor>

            <p style={{ marginTop: '2em' }}>
              Der Masterplan wurde 2012 als Teil der Mobilitätsstrategie
              erstellt und ist noch immer gültig.
            </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '25ContentRead'
              })
            }
          }}
        />

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='ziel' id='ziel-1'>
              <div className='left'>
                <img src={require('./images/bike.svg')} />
                <div className='tag'>
                  <span>Ziel 1</span>
                </div>
                <div className='text'>Anteil des Veloverkehrs steigern</div>
              </div>
              <div className='right'>
                <i className='icon check circle large' />
              </div>
            </h3>
            <p>
              Es ist realistisch, dass die Stadt den angestrebten Anteil
              Velofahrender am Stadtverkehr erreicht. Der Anteil aus dem Jahr
              2011 soll sich bis 2025 verdoppeln. Das zeigen die 21
              Zählstationen auf dem ganzen Stadtgebiet. Verglichen mit 2012
              fuhren 2018 in absoluten Zahlen 1,5 Mal mehr Personen Velo. Dies
              geht aus dem{' '}
              <a href='https://www.stadt-zuerich.ch/ted/de/index/taz/publikationen_u_broschueren/stadtverkehr_2025_bericht_2018.html'>
                neusten Zwischenbericht zum Stadtverkehr 2025
              </a>{' '}
              hervor. Fuss-, Tram- und Busverkehr sowie der motorisierte
              Individualverkehr blieben in dieser Zeitspanne dagegen konstant.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container iframe'>
            <h5>Städtische Verkehrsentwicklung, 2009–2018</h5>
            <div className='subline'>
              Indexpunkte (Basisjahr 2012 = 100 Punkte)
            </div>
            <AutofitIFrame
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/DTqes/'
              height={this.isTablet ? (this.isMobile ? '440' : '440') : '350'}
              width='600'
            />
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <p>
              Der Veloanteil am gesamten Stadtverkehr betrug laut der jüngsten
              Erhebung (Mikrozensus) aus dem Jahr 2015 rund 8 Prozent und hat
              sich in fünf Jahren verdoppelt. Misst man nur den Anteil der
              Stadtzürcher Bevölkerung, sind es 12 Prozent. Rund 115’000
              Personen fahren regelmässig Velo, das heisst 2- bis 3-mal pro
              Woche.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='ziel' id='ziel-2'>
              <div className='left'>
                <img src={require('./images/bike.svg')} />
                <div className='tag'>
                  <span>Ziel 2</span>
                </div>
                <div className='text'>Sicherheit der Velofahrer erhöhen</div>
              </div>
              <div className='right'>
                <i className='icon x circle large red' />
              </div>
            </h3>
            <p>
              Nimmt man die Anzahl Unfälle als Richtwert, so sind die Radwege
              noch längst nicht sicher genug. Die Anzahl der verunfallten
              Velofahrer hat in den vergangenen Jahren überproportional zum
              Verkehrswachstum zugenommen, 2018 waren es 25 Prozentpunkte im
              Vergleich zum Vorjahr. 50 Unfälle geschahen wegen nicht
              entsprechender Infrastruktur – wenn der Platz knapp ist und die
              Route unübersichtlich. Häufig kam es etwa in der Unterführung an
              der Langstrasse zu Unfällen. Dazu kommt eine hohe Dunkelziffer an
              Unfällen, die nicht gemeldet werden, insbesondere in der
              Innenstadt. Die ETH rechnet laut einer Umfrage mit 86 Prozent, wie
              die «NZZ am Sonntag» kürzlich publik machte. Viele nicht gemeldete
              Unfälle gibt es gemäss Umfrage rund um den Hauptbahnhof, am
              Limmatquai und am Stadelhofen. Die Zufriedenheit der Velofahrenden
              mit der Verkehrsqualität war 2018 mit dem Wert 3,8 (von 6) tief.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <p>
              Veloexperten sind sich einig: Die Stadtbevölkerung fährt nicht
              wegen der Infrastruktur mehr Velo, sondern weil es einem Zeitgeist
              entspricht. Die Voraussetzung wären gegeben, dass noch viel mehr
              Zürcherinnen und Zürcher Velo fahren. Die Zürcher Haushalte
              besitzen mindestens 380’000 Velos und 9500 E-Bikes, das hat das{' '}
              <a href='https://www.stadt-zuerich.ch/ted/de/index/taz/verkehr/webartikel/webartikel_mobilitaetsverhalten.html'>
                Tiefbauamt anhand des Mikrozensus
              </a>{' '}
              berechnet. Doch viele nutzen ihr Velo nicht, weil sie die
              Velorouten zu gefährlich finden.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='ziel' id='ziel-3'>
              <div className='left'>
                <img src={require('./images/bike.svg')} />
                <div className='tag'>
                  <span>Ziel 3</span>
                </div>
                <div className='text'>
                  Velofahren bei Kindern und Jugendlichen fördern
                </div>
              </div>
              <div className='right'>
                <i className='icon question circle large' />
              </div>
            </h3>
            <p>
              Die Stadt Zürich will Kinder und Jugendliche im Alltag und in der
              Freizeit zum Velofahren bewegen. In der Schule werden Kinder zum
              korrekten Fahren angeleitet. Wie sich diese Massnahmen auswirken,
              wird sich erst längerfristig zeigen. Klar ist: Die Velonutzung hat
              bei Kindern und Jugendlichen im Durchschnitt in den letzten 20
              Jahren abgenommen. Das zeigt eine neue Studie der Bundesämter für
              Gesundheit (BAG), Sport (Baspo) und Verkehr (Astra). Kinder legen
              die Wege im städtischen Alltag und der Freizeit eher zu Fuss, mit
              dem Kickboard oder im ÖV zurück. Bei den 13- bis 15-Jährigen ist
              der Veloanteil besonders stark zurückgegangen. Viele Eltern lassen
              ihre Kinder aus Angst vor einem Unfall erst ab einem gewissen
              Alter alleine in der Innenstadt Velo fahren.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <a href='https://interaktiv.tagesanzeiger.ch/2019/was-zuerich-wissen-will/?nosome'>
              <img
                src='https://interaktiv.tagesanzeiger.ch/2019/was-zuerich-wissen-will/mini-teaser-leserhinweis.png'
                width='100%'
              />
            </a>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='handlungsfeld' id='handlungsfeld-1'>
              <div className='left'>
                <img src={require('./images/work.svg')} />
                <div className='tag'>
                  <span>Handlungsfeld 1</span>
                </div>
                <div className='text'>Attraktive und sichere Infrastruktur</div>
              </div>
              <div className='right'>
                <i className='icon x circle large red' />
              </div>
            </h3>
            <p>
              Die Infrastruktur ist nur marginal verbessert worden. Konkret hat
              die Stadt in den vergangenen sechs Jahren die Sicherheit auf knapp
              12 des rund 100 Kilometer langen Hauptroutennetzes erhöht. Rupert
              Wimmer vom Tiefbauamt konstatiert: «Die Aufwertung der Routen für
              den Veloverkehr erfolgt nicht im angestrebten Masse.»
              Strassenbauprojekte hätten eine lange Entwicklungs- und
              Realisierungsdauer.
            </p>
            <p>
              Die Stadt hat das Netz in vier Routenqualitäten eingeteilt und
              strebt auf dem gesamten klassierten Netz die Qualitätsstufe A an.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui container' style={{ marginBottom: '2em' }}>
            <h5 style={{ margin: '1em 0' }}>
              Die Qualitätsstufen des Zürcher Hauptroutennetzes im Vergleich
            </h5>
            <img
              className='ui fluid image'
              src={
                this.isMobile
                  ? require('./images/qualitaetsstufen-mobile.jpg')
                  : require('./images/qualitaetsstufen.jpg')
              }
            />
            <div className='ta secondary caption'>
              Daten:{' '}
              <a href='https://www.stadt-zuerich.ch/ted/de/index/taz/publikationen_u_broschueren/stadtverkehr_2025_bericht_2018.html'>
                Stadt Zürich
              </a>
              , Fotos: Urs Jaudas, Grafik: Mathias Lutz
            </div>
          </div>

          <div className='ui text container'>
            <p>
              <ul>
                <li>
                  Mehr als die Hälfte des Netzes genügt den Minimalanforderungen
                  des Bundesamtes für Strassen (Astra) nicht. Dieses empfiehlt
                  1,50 Meter breite Radstreifen. Rund 37 Kilometer des
                  Hauptroutennetzes erfüllen lediglich die Zürcher
                  Minimalanforderungen (Stufe B) mit minimal breiten
                  Radwegmarkierungen auf der Strasse, etwa jene 1,25 Meter
                  breiten auf der Schaffhauserstrasse.
                </li>
                <li>
                  Akuter Handlungsbedarf besteht auf 19,7 Kilometern (Stufe C).
                  Dort weisen einzig Piktogramme oder Randeinfärbungen auf den
                  Radweg hin. Ein Beispiel ist die Langstrasse.{' '}
                </li>
                <li>
                  3,8 Kilometer sind das Highlight (Stufe A+) des Netzes. Da
                  sind die Radstreifen 1,80 Meter breit. Als Beispiel nennt die
                  Stadt den neuen Radweg an der Lagerstrasse.
                </li>
              </ul>
            </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '50ContentRead'
              })
            }
          }}
        />

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <p>
              Auf den rund 60 Kilometern des Komfortroutennetzes, auf dem sich
              auch Gelegenheitsfahrer wohlfühlen sollen und die
              Sicherheitsansprüche entsprechend höher sind, sieht es nicht viel
              besser aus.
            </p>
            <p>
              <ul>
                <li>
                  Dort erfüllen rund 36 Kilometer nicht die gewünschten
                  Anforderungen. So entspricht die Komfortroute Fischerweg
                  stadtauswärts entlang der Limmat der Qualitätsstufe B. Den
                  3,50 Meter breiten Weg teilen sich Fussgänger und Velofahrer.
                </li>
                <li>
                  Knapp 25 Kilometer erfüllen die angestrebten Voraussetzungen.
                  Die Komfortroute Tödistrasse verläuft auf einer 4,8 Meter
                  breiten Quartierstrasse (Stufe A), der geplante Radweg entlang
                  des Mythenquais ist 4,2 Meter breit (Stufe A+).{' '}
                </li>
              </ul>
            </p>
          </div>

          <div className='ui text container'>
            <p>
              Dazu kommen rund 180 Kilometer kommunal klassierte Routen, die
              ebenfalls im Richtplan eingetragen sind.
            </p>
            <p>
              144 weitere Kilometer sind im Richtplan als geplant markiert, aber
              nicht umgesetzt. Zählt man Strassen mit Begegnungszonen und
              Tempo-30-Abschnitten dazu sowie all jene Wege, auf denen der
              motorisierte Verkehr verboten ist, umfasst das Netz eine
              Gesamtlänge von 1032 Kilometern.
            </p>
          </div>

          <div
            className='ui vertical fitted segment'
            style={{ paddingBottom: '0.5em' }}
          >
            <div className='ui container'>
              <img
                className='ui fluid image'
                src={require('./images/velostaender.jpg')}
              />
              <div className='ta secondary caption'>
                Auch doppelstöckige Veloabstellplätze sind regelmässig
                überfüllt, wie das Beispiel am Bahnhof Altstetten zeigt. Foto:
                Urs Jaudas
              </div>
            </div>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <p>
              Wie schwierig die Umsetzung ist und wer alles mitredet, zeigt sich
              an drei Leuchtturmprojekten:
            </p>
            <p>
              <ul>
                <li>
                  Der Stadttunnel unter dem Hauptbahnhof, ein Überbleibsel des
                  Stadttunnel-Y, hätte bereits 2016 in Betrieb genommen werden
                  sollen. Die Realisierung dieser Verbindung ist schwierig, weil
                  der Tunnel Teil des Nationalstrassennetzes ist. Derzeit klärt
                  die Stadt mit dem Bund ab, ob die Rückbaukosten des Tunnels
                  als Investitionskosten eingerechnet werden müssen. Wenn ja,
                  braucht es für die Neunutzung eine Volksabstimmung,
                  voraussichtlich im Frühling 2021. Der Baustart ist auf den
                  Frühsommer 2022 angesetzt.
                </li>
                <li>
                  Die Veloroute Seebecken, ebenfalls auf 2016 terminiert, wurde
                  nur teilweise umgesetzt. Der 2-Richtungs-Radweg auf der
                  Quaibrücke ist realisiert. Ein ähnlicher am Utoquai muss neu
                  geplant werden, weil gegen das Fällen von Bäumen Einsprachen
                  vom Naturschutz und dem VCS eingingen. Neu dürfte der Veloweg
                  auf der Bellerivestrasse geführt werden. Der Prozess soll
                  diesen Herbst beginnen. Auf der linken Seite sind die
                  Abschnitte am Mythenquai gemäss Planung bis 2021 umgesetzt, am
                  General-Guisan-Quai wird mit dem Bau 2023 begonnen.
                </li>
                <li>
                  Die Viaduktverlängerung, ein weiteres Leuchtturmprojekt, aber
                  nicht Teil des Masterplans, soll 2023 gebaut werden. Hier ist
                  laut Stadt die Anbindung an das Strassen- und Wegnetz an
                  beiden Brückenköpfen verkehrsplanerisch und städtebaulich
                  herausfordernd.
                </li>
              </ul>
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <p>
              <strong>Kleine Massnahmen</strong>
            </p>
            <p>
              Die Stadt hat diverse einfache Massnahmen getroffen, etwa den
              Velostreifen am Sihlquai oder einen vorgezogenen Haltebalken an
              der Werdstrasse. Die Arbeitsgruppe Velo Sicuro kümmert sich neu
              zusätzlich darum, Unfallbrennpunkte zu analysieren und mit
              Sofortmassnahmen zu entschärfen. Sie hat etwa Plakate an der
              Fussgänger- und Velounterführung beim Bahnhof Altstetten angeregt.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <p>
              <strong>Abstellplätze</strong>
            </p>
            <p>
              In Zürich gibt es mittlerweile 2000 öffentlich zugängliche
              Abstellanlagen für insgesamt 43’000 Zweiräder. Pro
              Quadratkilometer können in Zürich durchschnittlich rund 500 Velos
              abgestellt werden. Das ist weniger Platz als für Autos – im
              Schnitt gibt es 783 öffentlich zugängliche Parkplätze je
              Quadratkilometer.
            </p>
            <p>
              Die meisten Veloabstellplätze sind indes zu klein geplant. Die
              neue Anlage beim Bahnhof Oerlikon etwa, 2017 für 1600 Velos
              eröffnet, ist bereits zu klein. Bei der Erweiterung des Bahnhofs
              Stadelhofen gibt es ernsthafte Zweifel daran, ob die 1000
              kostenpflichtigen und 300 oberirdischen Abstellplätze ausreichen.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='handlungsfeld' id='handlungsfeld-2'>
              <div className='left'>
                <img src={require('./images/work.svg')} />
                <div className='tag'>
                  <span>Handlungsfeld 2</span>
                </div>
                <div className='text'>
                  Rücksichtnahme aller Verkehrsteilnehmenden
                </div>
              </div>
              <div className='right'>
                <i className='icon x circle large red' />
              </div>
            </h3>
            <p>
              Das Klima unter den diversen Verkehrsteilnehmern ist gemäss Stadt
              aggressiver geworden. Vielerorts entspricht die Infrastruktur
              nicht der Menge an Velofahrern, häufig fehlt der ausschliesslich
              für die Velofahrenden vorgesehene Raum. Die steigende Zahl an
              E-Bikes, Lastenvelos und E-Trottinetten verschärft das Problem
              zusätzlich. Teilweise weichen Velofahrende deshalb aufs Trottoir
              aus, was wiederum Fussgängerinnen und Fussgänger erzürnt, weil sie
              um ihre Sicherheit bangen. Aus Sicht der Stadt ist ein separater
              Raum für Velofahrende nicht realisierbar, da die Strassenräume zu
              knapp und die Nutzungsansprüche zu vielfältig seien. Mit Kampagnen
              für die gegenseitige Rücksichtnahme sowie gezieltem Büssen von
              regelwidrigen Velofahrern versuchte die Stadt die Atmosphäre zu
              verbessern – mit mässigem Erfolg.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='handlungsfeld' id='handlungsfeld-3'>
              <div className='left'>
                <img src={require('./images/work.svg')} />
                <div className='tag'>
                  <span>Handlungsfeld 3</span>
                </div>
                <div className='text'>
                  Verkehrsmittel für alle Altersgruppen
                </div>
              </div>
              <div className='right'>
                <i className='icon check circle large' />
              </div>
            </h3>
            <p>
              Die Stadt unternimmt viel, Kinder und Jugendliche zum Velofahren
              zu bewegen. Heute gibt es in jedem Schulkreis eine ausgeschilderte
              Veloprüfungsroute, jedes Schulkind erhält eine Veloschulung,
              selbst Veloflicknachmittage werden angeboten. Zudem gibt es in der
              Stadt zahlreiche Bikeparks. Studenten und Arbeitnehmende motiviert
              die Stadt gezielt zur Velonutzung, bei Grossanlässen fokussiert
              sie auf eine Anreise mit dem Velo.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='handlungsfeld' id='handlungsfeld-4'>
              <div className='left'>
                <img src={require('./images/work.svg')} />
                <div className='tag'>
                  <span>Handlungsfeld 4</span>
                </div>
                <div className='text'>Verankerung in der Verwaltung</div>
              </div>
              <div className='right'>
                <i className='icon x circle large red' />
              </div>
            </h3>
            <p>
              In der Verwaltung ist das Bewusstsein, das Velofahren zu fördern,
              theoretisch vorhanden, und die Angestellten sind vermehrt mit dem
              Velo unterwegs. Gemäss Stadt wird die Veloförderung bei jedem
              Strassenbauprojekt berücksichtigt. Praktisch aber sieht man gerade
              am Beispiel der neuen Route an der Ecke{' '}
              <a href='https://www.tagesanzeiger.ch/30553073'>
                Langstrasse/Lagerstrasse
              </a>
              , dass die Radwegführung nicht bis ins letzte Detail durchdacht
              ist. Die Wartestelle vor dem Club Gonzo ist bereits jetzt zu
              Pendlerzeiten zu klein bemessen, vor dem 25 Hours Hotel ist die
              Querung der Lagerstrasse nicht verständlich signalisiert.
            </p>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui container'>
            <img
              className='ui fluid image'
              src={require('./images/langstrasse-lagerstrasse.jpg')}
            />
            <div className='ta secondary caption'>
              An der Ecke Lagerstrasse/Langstrasse ist die Verkehrsführung für
              Velos nicht bis ins letzte Detail durchdacht. Foto: Urs Jaudas
            </div>
          </div>
        </div>

        <div
          className='ui vertical fitted segment'
          style={{ paddingBottom: '0.5em' }}
        >
          <div className='ui text container'>
            <h3 className='handlungsfeld' id='handlungsfeld-5'>
              <div className='left'>
                <img src={require('./images/work.svg')} />
                <div className='tag'>
                  <span>Handlungsfeld 5</span>
                </div>
                <div className='text'>
                  Mehr Dienstleistung und Kommunikation
                </div>
              </div>
              <div className='right'>
                <i className='icon question circle large' />
              </div>
            </h3>
            <p>
              Mit der Realisierung des automatischen Verleihsystems Publibike
              hat die Stadt eine wichtige und sichtbare Dienstleistung zur
              Veloförderung geschaffen. Zudem stehen an neuralgischen Orten in
              der Stadt Velopumpen. Eine Werbekampagne, die ins Auge sticht und
              das Image des Velofahrens verbessern würde, fehlt indes.
            </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: '75ContentRead'
              })
            }
          }}
        />

        <div
          className='ui vertical fitted segment'
          style={{
            padding: '4em 0 1em',
            marginTop: '2em',
            background: '#f5f5f5'
          }}
        >
          <div className='ui text container'>
            <h2>Fragen & Antworten</h2>
            <h3 className='frage'>
              Wie steht Zürich im Vergleich mit anderen Städten da?
            </h3>
            <p>
              Vergleicht man den Anteil der Stadtbevölkerung, der 2015 Velo
              gefahren ist, so bleibt Zürich mit 12 Prozent hinter Basel (17%),
              Bern und Winterthur (je 15) zurück.
            </p>
            <AutofitIFrame
              aria-label='Interactive chart'
              src='//datawrapper.dwcdn.net/6BbwU/'
              height={this.isTablet ? (this.isMobile ? '400' : '400') : '350'}
              width='600'
            />
            <p>
              Der Vergleich der binnenpendelnden Arbeitstätigen in den
              verschiedenen Städten zeigt auf, wo Zürich Potenzial hätte. Über
              ein Drittel der Stadtbevölkerung in Bern und Winterthur fährt mit
              dem Velo zur Arbeit. In Zürich sind es lediglich 22 Prozent.
            </p>
            <AutofitIFrame
              aria-label='Interactive chart'
              src='//datawrapper.dwcdn.net/NFPa9/'
              height={this.isTablet ? (this.isMobile ? '400' : '400') : '350'}
              width='600'
            />
            <p>
              Ein Vergleich der Längen an Velostreifen und Velowegen mit anderen
              Städten ist derzeit nicht möglich, da die Stadt Zürich ihre für
              den Veloverkehr zur Verfügung stehenden Fahrstreifen und -wege
              anders berechnet.
            </p>

            <h3 className='frage'>Liegt es am Geld?</h3>
            <p>
              Nein. Der Gemeinderat hat 2015 einen Rahmenkredit von 120
              Millionen Franken bewilligt, mit dem der Stadtrat in
              abschliessender Kompetenz kommunale Routen und Abstellplätze
              bewilligen kann. Er wurde bisher kaum angetastet, da kommunale
              Routen oft auf Nebenstrassen verlaufen, teilweise in
              Tempo-30-Zonen, und deshalb nur wenig Veloinfrastrukturen
              erfordern. Genaue Zahlen zu den Ausgaben nennt die Stadt nicht.
            </p>

            <h3 className='frage'>Was könnte sich bald ändern?</h3>
            <p>
              Setzt der Tiefbauvorsteher Richard Wolff (AL) seine Ankündigungen
              in der Klimadebatte des Gemeinderats Ende September in Taten um,
              so dürfte es demnächst tatsächlich vorwärtsgehen mit den
              Velowegen. Er will den Raum neu zugunsten von Fussgängern, ÖV und
              Velo verteilen. Er sagte: «Den Platz, den wir für die Velowege
              brauchen, nehmen wir von den Fahrbahnen und den Parkplätzen.»{' '}
            </p>
            <p>
              Kleine Verbesserungen wird es bald an der Langstrasse geben. In
              den nächsten Monaten soll in der Unterführung auf dem
              Strassentrassee ein weiterer Velostreifen markiert werden. Sobald
              die Lagerstrasse und die Kanonengasse fertig gebaut sind, wird die
              Langstrasse Richtung Helvetiaplatz umgestaltet – mit einer
              offiziellen Veloführung in beide Richtungen, weil tagsüber keine
              Autos mehr verkehren. Die Velorouten-Initiative der linken
              Parteien und velofreundlichen Verbände könnte ein weiteres
              Druckmittel für die Stadt sein, Velorouten aufzuwerten. Innert 10
              Jahren sollen 50 Kilometer durchgängige Velorouten durch alle
              Quartiere entstehen, auf denen keine Autos verkehren. Der Stadtrat
              befürwortet diese, weil er sich nicht auf einen Gegenvorschlag
              hatte einigen können. Die Vorlage wird frühestens nächsten Sommer
              zur Abstimmung kommen. Es gibt indes Zweifel daran, ob die Stadt
              diese tatsächlich innerhalb der Frist umsetzen wird. Die Stadt
              prüft, die Strategie und die Massnahmen des Masterplans
              anzupassen. Einen neuen Masterplan wird es gemäss Stadt vorerst
              nicht geben.
            </p>

            <h3 className='frage'>
              Was braucht darüber hinaus aus Sicht von Experten?
            </h3>
            <p>
              Rupert Wimmer, Leiter Verkehr und Stadtraum des Tiefbauamts der
              Stadt Zürich, sagt: «Es braucht einfache, rasch umsetzbare
              Massnahmen, um Velofahren in der Stadt attraktiver und sicherer zu
              machen. So haben wir zur grösseren Sicherheit der Velofahrenden
              etwa am Sihlquai vorübergehend einen Radstreifen markiert. Zudem
              wird es zukünftig ein wichtiges Ziel sein, die gegenseitige
              Rücksichtnahme und das Miteinander im Strassenraum zu fördern.»
            </p>
            <p>
              Markus Knauss (Grüne), Gemeinderat und CO-Geschäftsführer VCS
              Zürich, sagt: «Es braucht den absoluten Willen in der
              Stadtverwaltung, diese Stadt wirklich velofreundlich zu machen.
              Das braucht Mut zu Lösungen, die nicht bei allen beliebt sind. Sie
              dürfen aber nicht auf Kosten der Fussgänger gehen.»
            </p>
            <p>
              Dave Durner, Geschäftsführer von Pro Velo Kanton Zürich, sagt: «Es
              braucht mehr personelle Ressourcen. Ein Velobeauftragter und ein
              Projektleiter genügen nicht. Bern hat dreimal so viele Leute.»
            </p>
            <p>
              Die Berner Tiefbauvorsteherin Ursula Wyss (SP) sagt: «Städte
              müssen heute Prioritäten setzen. ÖV, Velos und Fussgängerinnen und
              Fussgänger haben Vortritt. Wenn man immerzu an einen Kompromiss
              mit dem Auto denkt, scheitert das Vorhaben. Eine velofreundliche
              Verkehrspolitik braucht Platz – auf Kosten des Autos.»
            </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'contentBottom'
              })
            }
          }}
        />

        {/* TODO Add your credits in this component */}
        <Footer
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            ['Text und Recherche', 'Ev Manz'],
            [
              'Konzept und Programmierung',
              'Mathias Lutz und Marc Brupbacher, Interaktiv-Team'
            ],
            ['Fotos/Videos', 'Urs Jaudas']
          ]}
          hidePortfolioTeaser
        />

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'pageBottom'
              })
            }
          }}
        />
      </div>
    )
  }
}

export default hot(AppComponent)
